import { FC } from 'react';
import { IonButton, IonCard, IonCardContent, IonRow } from '@ionic/react';
import { DqText } from '../dq-text';
import './SupportCard.scss';

export interface SupportCardProps {
  /**
   *  The function to be called when the button is clicked
   */
  onClick?: () => void;
  /**
   * The text to be displayed on the button
   */
  buttonText?: string;
  /**
   * The subtitle of the card
   */
  subtitle: string;
  /**
   * The title of the card
   */
  title: string;
}

const SupportCard: FC<SupportCardProps> = ({ buttonText, title, subtitle, onClick }) => {
  return (
    <IonCard className="support-card">
      <IonCardContent className="ion-flex ion-align-items-start">
        <IonRow>
          <DqText variant="h3" color="dark">
            {title}
          </DqText>
        </IonRow>
        <IonRow className="ion-margin-vertical">
          <DqText variant="body" color="dark">
            {subtitle}
          </DqText>
        </IonRow>
        {buttonText && (
          <IonButton className="support-button ion-margin-top" fill="outline" color="dark" onClick={onClick}>
            {buttonText}
          </IonButton>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default SupportCard;
